<mat-card class="cardWithShadow theme-card">
  <mat-card-header>
    <div class="header-container">
      <mat-card-title class="m-b-0">Application Logs</mat-card-title>
    </div>
  </mat-card-header>
  <mat-card-content class="b-t-1">
    <br />

    <!-- Active Filters Display - TK 01/15/2025 -->
    <app-active-filters
      [filters]="searchInterface"
      [headerMap]="headerMap"
      [defaultFilters]="defaultFilters"
      title="Application Log Filters"
      [showFilterButton]="true"
      filterButtonTooltip="Filter all columns"
      (clearAll)="clearFilters()"
      (clearFilter)="clearFilter($event)"
      (openFilterDialog)="openGlobalFilterDialog()"
    >
    </app-active-filters>

    <mat-card class="cardWithShadow theme-card">
      <mat-card-content class="b-t-1">
        <div class="table-container">
          <mat-table #table [dataSource]="dataSource" matSort class="mat-table">
            <ng-container matColumnDef="logDate">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('logDate').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.logDate"
              >
                {{ element.logDate }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="logID">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('logID').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.logID"
              >
                {{ element.logID }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="type">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('type').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.type"
              >
                {{ element.type }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="typeDescription">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('typeDescription').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.typeDescription"
              >
                {{ element.typeDescription }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="description">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('description').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.description"
              >
                {{ element.description }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="applicationName">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('applicationName').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.applicationName"
              >
                {{ element.applicationName }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="applicationId">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('applicationId').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.applicationId"
              >
                {{ element.applicationId }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="ip">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('ip').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.ip"
              >
                {{ element.ip }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="userName">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('userName').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.userName"
              >
                {{ element.userName }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="recordDate">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('recordDate').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.recordDate"
              >
                {{ element.recordDate }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="recordTime">
              <mat-header-cell
                *matHeaderCellDef
                class="f-w-600 mat-subtitle-1 f-s-14"
              >
                {{ headerMap.get('recordTime').label }}
              </mat-header-cell>

              <mat-cell
                class="p-16"
                *matCellDef="let element"
                class="mat-body-1"
                [title]="element.recordTime"
              >
                {{ element.recordTime }}</mat-cell
              >
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="customMat"
              (dblclick)="selection.toggle(row); showDetail(row, 'View')"
              [ngClass]="{ highlight: selectedRow === row }"
              (click)="highlight(row)"
            ></mat-row>
          </mat-table>
        </div>

        <mat-paginator
          #paginator
          [showFirstLastButtons]="true"
          [length]="dataSource.counter$ | async"
          [pageIndex]="0"
          [pageSize]="10"
          [pageSizeOptions]="[10, 20, 50, 100, 500, 1000, 5000, 10000, 100000]"
        >
        </mat-paginator> </mat-card-content
    ></mat-card>

    <!-- Back to Applications table — bottom left 21/07/2026 DW -->
    <div class="back-button-row">
      <button mat-raised-button color="accent" type="button" (click)="goBack()">
        Back
      </button>
    </div>
  </mat-card-content>
</mat-card>
